import {
  Container,
  Content,
  Actions,
  ApprovedStatus,
  PendingStatus,
  ReprovedStatus,
  BtnUpload,
  BtnDownload,
  BtnRefresh,
  BtnTrash,
  LoadingContainer,
  LoadingSpinner,
  StatsContainer,
  StatsCard,
  StatsIcon,
  StatsContent,
  StatsNumber,
  StatsLabel,
  UploadIcon,
  BtnInfo,
  DocumentNameContainer,
  DocumentNameText,
} from "./styles";
import { BsDownload, BsInfoCircle, BsTrash } from "react-icons/bs";
import { VscRefresh } from "react-icons/vsc";
import LogoCircle from "../../assets/images/Informa_Logo_Circle.png";
import { IoCheckmarkSharp } from "react-icons/io5";
import { IoCloseSharp } from "react-icons/io5";
import Spinner from "../../newUXAssets/icons/Spinner";

import { useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import Table from "../../newUXComponents/Table";
import { useMemo, useState, useEffect, useCallback, useRef } from "react";
import SendDocumentModal from "./components/SendDocumentModal";
import api from "../../service";
import { useSelector, useDispatch } from "react-redux";
import useNotification from "../../hooks/newUXNotification";
import ConfirmationModal from "../../newUXComponents/Modal/ConfirmationModal";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import { useLoading } from "../../hooks/loading";
import {
  checkMandatoryDocuments,
  fetchDocumentsList,
} from "../../redux/modules/documentRequired/actions";
import { Tooltip } from "antd";
import InfoIcon from "../../newUXAssets/icons/Info";
import ExpandedDocumentRow from "./components/ExpandedDocumentRow";
import { fetchPackageInternalDocuments } from "../../service/uploadFlow.service";
import useDocumentDownload from "./components/UseDocumentDownload";

dayjs.extend(customParseFormat);
dayjs.extend(utc);

const DOCUMENT_NAME_COLUMN_WIDTH = 200;
const FLOW_NAME_COLUMN_WIDTH = 170;
const SEND_DATE_COLUMN_WIDTH = 140;
const ORIGIN_COLUMN_WIDTH = 120;
const UPLOADED_BY_COLUMN_WIDTH = 160;
const STATUS_COLUMN_WIDTH = 260;
const JUSTIFICATION_COLUMN_WIDTH = 140;
const OBSERVATION_COLUMN_WIDTH = 140;
const ACTION_COLUMN_WIDTH = 100;
const SUBMITTED_TABLE_MIN_WIDTH =
  DOCUMENT_NAME_COLUMN_WIDTH +
  FLOW_NAME_COLUMN_WIDTH +
  SEND_DATE_COLUMN_WIDTH +
  ORIGIN_COLUMN_WIDTH +
  UPLOADED_BY_COLUMN_WIDTH +
  STATUS_COLUMN_WIDTH +
  JUSTIFICATION_COLUMN_WIDTH +
  OBSERVATION_COLUMN_WIDTH +
  ACTION_COLUMN_WIDTH;

const DocumentNotSend = (activeTab) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { contract, event } = useSelector((state) => state.initialSettings);
  const { token, user } = useSelector((state) => state.auth);
  const { documentsList, documentsLoading } = useSelector(
    (state) => state.documentRequired,
  );
  const [documentId, setDocumentId] = useState(null);
  const [opportunityId, setOpportunityId] = useState(null);
  const [eventId, setEventId] = useState(null);
  const [documentName, setDocumentName] = useState("");
  const [allowedFileExtensions, setAllowedFileExtensions] = useState("");
  const [modalSendDocumentVisible, setModalSendDocumentVisible] =
    useState(false);
  const { id } = useParams();
  const [searchPendingDocs, setSearchPendingDocs] = useState("");
  const [searchSubmittedDocs, setSearchSubmittedDocs] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [documentToDelete, setDocumentToDelete] = useState(null);
  const { handleLoading } = useLoading();
  const notification = useNotification();

  const notificationRef = useRef(notification);
  useEffect(() => {
    notificationRef.current = notification;
  }, [notification]);

  // Estados para dados originais (sem filtros)
  const [originalPendingDocs, setOriginalPendingDocs] = useState([]);
  const [originalSubmittedDocs, setOriginalSubmittedDocs] = useState([]);

  // Estados para dados filtrados e paginados
  const [filteredPendingDocs, setFilteredPendingDocs] = useState([]);
  const [filteredSubmittedDocs, setFilteredSubmittedDocs] = useState([]);

  const [isPackage, setIsPackage] = useState(false);
  const [packageDocuments, setPackageDocuments] = useState([]);
  const [flowName, setFlowName] = useState("");

  const [isLoadingDocs, setIsLoadingDocs] = useState(false);

  const [tablePaginationPending, setTablePaginationPending] = useState({
    current: 1,
    defaultCurrent: 1,
    pageSize: 5,
    showQuickJumper: true,
    total: 0,
  });
  const [tablePaginationSubmitted, setTablePaginationSubmitted] = useState({
    current: 1,
    defaultCurrent: 1,
    pageSize: 5,
    showQuickJumper: true,
    total: 0,
  });

  const { handleDownload } = useDocumentDownload();

  const userLogged = user.role.type;

  const formatDate = useCallback(
    (date) => {
      if (!date) return " - ";

      const locale = intl.locale;

      if (locale === "en" || locale === "en-US") {
        // M/D = sem zeros à esquerda, h:mm A = 12 horas AM/PM
        return dayjs(date).format("M/D/YYYY [at] h:mm A");
      } else {
        // HH:mm = 24 horas
        return dayjs(date).format("DD/MM/YYYY [às] HH:mm");
      }
    },
    [intl.locale],
  );

  const handleSendFile = useCallback(
    (id, name, allowedFileExtensions, recordFlowName = "") => {
      const extensions = Array.isArray(allowedFileExtensions)
        ? allowedFileExtensions.join(", ")
        : "";

      setAllowedFileExtensions(extensions);
      setDocumentId(id);
      setDocumentName(name);
      setOpportunityId(contract.value);
      setFlowName(recordFlowName);
      setEventId(event.value);
      setIsPackage(false);
      setPackageDocuments([]);
      setModalSendDocumentVisible(true);
    },
    [contract.value, event.value],
  );

  const handleSendPackage = useCallback(
    async (parentRecord = {}) => {
      try {
        handleLoading(true);

        const data = await fetchPackageInternalDocuments({
          eventId: event.value,
          uploadFlowId: parentRecord.id,
          token,
          params: {
            opportunityId: contract.value,
            ...(parentRecord.idExecution && {
              executionId: parentRecord.idExecution,
            }),
          },
        });

        const list = Array.isArray(data) ? data : (data?.documents ?? []);

        const rows = list.map((doc) => ({
          ...doc,
          id: doc.documentConfigId,
          fileName: doc.fileName ?? "",
        }));

        const extensions = [
          ...new Set(rows.flatMap((row) => row.fileTypes ?? [])),
        ].join(", ");

        setIsPackage(Boolean(parentRecord.documentPackage));
        setPackageDocuments(rows);
        setDocumentId(parentRecord.id);
        setDocumentName(parentRecord.fileName ?? "");
        setFlowName(parentRecord.flowName ?? "");
        setOpportunityId(contract.value);
        setEventId(event.value);
        setAllowedFileExtensions(extensions);
        setModalSendDocumentVisible(true);
      } catch (err) {
        notification.displayError(
          intl.formatMessage({ id: "expanded_documents.fetch_error" }),
          "fetch-package-documents-error",
        );
      } finally {
        handleLoading(false);
      }
    },
    [contract.value, event.value, token, intl, notification, handleLoading],
  );

  const handleRemoveFile = useCallback((record) => {
    setDocumentToDelete(record);
    setDeleteModalOpen(true);
  }, []);

  const columnsWait = useMemo(
    () => [
      {
        title: intl.formatMessage({ id: "document_name" }),
        dataIndex: "fileName",
        key: "fileName",
        width: "40%",
        render: (text) =>
          text === "document_package"
            ? intl.formatMessage({ id: "document_package" })
            : text || "-",
      },
      {
        title: intl.formatMessage({ id: "flow_name" }),
        dataIndex: "flowName",
        key: "flowName",
        width: "40%",
        render: (text) => text || "-",
      },
      {
        title: intl.formatMessage({ id: "mandatory" }),
        dataIndex: "mandatory",
        key: "mandatory",
        width: "45%",
        render: (mandatory) => {
          return mandatory
            ? intl.formatMessage({ id: "yes" })
            : intl.formatMessage({ id: "no" });
        },
      },
      {
        title: intl.formatMessage({ id: "actions" }),
        dataIndex: "action",
        key: "action",
        align: "center",
        width: "15%",
        render: (_, record) => {
          if (record.status !== "PENDING" || record.url !== null) return null;

          // Pacote: 1 único botão na linha pai que dispara o envio em lote.
          if (record.documentPackage) {
            return (
              <Actions justifyContent={"center"}>
                <BtnUpload onClick={() => handleSendPackage(record)}>
                  <div>
                    <UploadIcon size={24} />
                  </div>
                  {intl.formatMessage({ id: "send_package" })}
                </BtnUpload>
              </Actions>
            );
          }

          // Documento avulso (não-pacote)
          return (
            <Actions justifyContent={"center"}>
              <BtnUpload
                onClick={() =>
                  handleSendFile(
                    record.id,
                    record.fileName,
                    record.allowedFileTypes,
                    record.flowName,
                  )
                }
              >
                <div>
                  <UploadIcon size={24} />
                </div>
                {intl.formatMessage({ id: "send_file" })}
              </BtnUpload>
            </Actions>
          );
        },
      },
    ],
    [intl, handleSendFile, handleSendPackage],
  );

  const columnsSend = useMemo(
    () => [
      {
        title: intl.formatMessage({ id: "document_name" }),
        dataIndex: "fileName",
        key: "fileName",
        width: DOCUMENT_NAME_COLUMN_WIDTH,

        responsive: ["xs", "sm", "md", "lg", "xl"],
        render: (_, record) => (
          <DocumentNameContainer>
            <DocumentNameText
              style={{
                display: "block",
                maxWidth: 160,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              title={
                record.fileName === "document_package"
                  ? intl.formatMessage({ id: "document_package" })
                  : record.fileName
              }
            >
              {record.fileName === "document_package"
                ? intl.formatMessage({ id: "document_package" })
                : record.fileName}
            </DocumentNameText>
          </DocumentNameContainer>
        ),
      },
      {
        title: intl.formatMessage({ id: "flow_name" }),
        dataIndex: "flowName",
        key: "flowName",
        width: FLOW_NAME_COLUMN_WIDTH,

        render: (text) => <span title={text || "-"}>{text || "-"}</span>,
      },
      {
        title: intl.formatMessage({ id: "send_date" }),
        dataIndex: "createdAt",
        key: "createdAt",
        width: SEND_DATE_COLUMN_WIDTH,

        responsive: ["sm", "md", "lg", "xl"],
        render: (text) => (
          <span style={{ whiteSpace: "nowrap" }}>{formatDate(text)}</span>
        ),
      },
      {
        title: intl.formatMessage({ id: "origin" }),
        dataIndex: "uploadOrigin",
        key: "origin",
        width: ORIGIN_COLUMN_WIDTH,

        responsive: ["md", "lg", "xl"],
        render: (_, record) =>
          intl.formatMessage({
            id: record?.uploadOrigin?.toLowerCase() || "-",
          }),
      },
      {
        title: intl.formatMessage({ id: "uploadedBy" }),
        dataIndex: "uploadedBy",
        key: "uploadedBy",
        width: UPLOADED_BY_COLUMN_WIDTH,

        responsive: ["lg", "xl"],
        render: (_, record) => {
          const { uploadOrigin, showContractScopedDocument } = record;

          switch (uploadOrigin) {
            case "CLIENT":
              if (showContractScopedDocument) {
                return "-";
              }
              if (userLogged === "SERVICE_PROVIDER") {
                return intl.formatMessage({ id: "sent_by_exhibitor" });
              }
              if (userLogged === "EXHIBITOR") {
                return intl.formatMessage({ id: "sent_by_provider" });
              }
              return "-";

            case "PARTNER":
              return intl.formatMessage({ id: "sent_by_partner" });

            case "E-COMMERCE":
              return intl.formatMessage({ id: "sent_by_ecommerce" });

            case "CONTRACT":
              return intl.formatMessage({ id: "sent_by_contract" });

            default:
              return "-";
          }
        },
      },
      {
        title: intl.formatMessage({ id: "status" }),
        dataIndex: "status",
        key: "status",
        align: "center",
        width: STATUS_COLUMN_WIDTH,

        responsive: ["xs", "sm", "md", "lg", "xl"],
        render: (_, record) => (
          <>
            {record.status === "PENDING" && (
              <PendingStatus>
                {String(
                  intl.formatMessage({ id: "documents.under_analysis" }),
                ).toLowerCase()}
              </PendingStatus>
            )}

            {record.status === "APPROVED" && (
              <ApprovedStatus>
                {String(intl.formatMessage({ id: "approved" })).toLowerCase()}
              </ApprovedStatus>
            )}

            {record.status === "APPROVED_BY_SYSTEM" && (
              <ApprovedStatus
                title={intl.formatMessage({ id: "approved_by_system" })}
              >
                {String(
                  intl.formatMessage({ id: "approved_by_system" }),
                ).toLowerCase()}
              </ApprovedStatus>
            )}

            {record.status === "REJECTED" && (
              <Tooltip
                color="#E8E8E8"
                placement="top"
                overlayInnerStyle={{
                  width: 430,
                  padding: "8px 16px",
                  background: "#E8E8E8",
                  borderRadius: "8px",
                }}
                title={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                    }}
                  >
                    <InfoIcon size={26} color="#343434CC" />
                    <span style={{ fontWeight: 600, color: "#343434" }}>
                      {intl.formatMessage({
                        id: "reproved_status_tooltip",
                      })}
                    </span>
                  </div>
                }
              >
                <ReprovedStatus>
                  {String(intl.formatMessage({ id: "reproved" })).toLowerCase()}
                </ReprovedStatus>
              </Tooltip>
            )}
          </>
        ),
      },
      {
        title: intl.formatMessage({ id: "rejection_reason" }),
        dataIndex: "justification",
        key: "justification",
        width: JUSTIFICATION_COLUMN_WIDTH,

        responsive: ["lg", "xl"],
        render: (text, record) => {
          if (record.status === "REJECTED" && text?.trim()) {
            return (
              <Tooltip title={text} placement="top">
                <span
                  style={{
                    display: "block",
                    maxWidth: 110,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {text}
                </span>
              </Tooltip>
            );
          }
          return " ";
        },
      },
      {
        title: intl.formatMessage({ id: "reviewer_comment" }),
        dataIndex: "observation",
        key: "observation",
        width: OBSERVATION_COLUMN_WIDTH,

        responsive: ["lg", "xl"],
        render: (text, record) => {
          if (record.status === "REJECTED") {
            if (text?.trim()) {
              return (
                <Tooltip title={text} placement="top">
                  <span
                    style={{
                      display: "block",
                      maxWidth: 110,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {text}
                  </span>
                </Tooltip>
              );
            }
          }

          return " ";
        },
      },
      {
        title: intl.formatMessage({ id: "action" }),
        key: "action",
        align: "center",
        width: ACTION_COLUMN_WIDTH,

        fixed: "right",
        responsive: ["xs", "sm", "md", "lg", "xl"],
        render: (_, record) => {
          const isPackage = Boolean(record.documentPackage);

          const packageItems = isPackage
            ? (record.items ?? [])
                .filter((item) => item.downloadAllowed && item.urlForDownload)
                .map(({ urlForDownload, documentExecutionId }) => ({
                  urlForDownload,
                  documentExecutionId,
                }))
            : [];

          const canDelete = record.status === "PENDING";
          return (
            <Actions>
              {canDelete && (
                <BtnTrash
                  disabled={!record.showContractScopedDocument}
                  onClick={() => handleRemoveFile(record)}
                >
                  <Tooltip
                    title={
                      !record.showContractScopedDocument
                        ? intl.formatMessage({
                            id: "upload_documents_client.showContractScopedDocument",
                          })
                        : intl.formatMessage({ id: "delete" })
                    }
                  >
                    <BsTrash size={22} />
                  </Tooltip>
                </BtnTrash>
              )}

              {record.status === "APPROVED" &&
                (isPackage ? packageItems.length > 0 : record.url !== null) && (
                  <BtnDownload
                    onClick={() =>
                      handleDownload(
                        isPackage ? packageItems : record.url,
                        record.idExecution,
                      )
                    }
                  >
                    <Tooltip
                      title={intl.formatMessage({
                        id: "download_file_available",
                      })}
                    >
                      <BsDownload size={22} />
                    </Tooltip>
                  </BtnDownload>
                )}

              {record.status === "APPROVED_BY_SYSTEM" &&
                !record.purchasedThroughEcommerce &&
                (isPackage ? packageItems.length > 0 : record.url !== null) && (
                  <BtnDownload
                    onClick={() =>
                      handleDownload(
                        isPackage ? packageItems : record.url,
                        record.idExecution,
                      )
                    }
                  >
                    <Tooltip
                      title={intl.formatMessage({
                        id: "download_file_available",
                      })}
                    >
                      <BsDownload size={22} />
                    </Tooltip>
                  </BtnDownload>
                )}

              {record.status === "APPROVED_BY_SYSTEM" &&
                record.purchasedThroughEcommerce && (
                  <BtnInfo>
                    <Tooltip
                      placement="left"
                      title={intl.formatMessage({
                        id: "document_purchase_ecommerce.info",
                      })}
                    >
                      <BsInfoCircle size={22} />
                    </Tooltip>
                  </BtnInfo>
                )}

              {record.status === "REJECTED" && (
                <>
                  {(isPackage ? packageItems.length > 0 : record.url) && (
                    <BtnDownload
                      onClick={() =>
                        handleDownload(
                          isPackage ? packageItems : record.url,
                          record.idExecution,
                        )
                      }
                    >
                      <Tooltip
                        title={intl.formatMessage({
                          id: "download_rejected_document",
                        })}
                      >
                        <BsDownload size={22} />
                      </Tooltip>
                    </BtnDownload>
                  )}

                  <BtnRefresh
                    disabled={record.resent || record.dispensed}
                    onClick={() =>
                      isPackage
                        ? handleSendPackage(record)
                        : handleSendFile(
                            record.id,
                            record.fileName,
                            record.allowedFileTypes,
                            record.flowName,
                          )
                    }
                  >
                    <Tooltip
                      placement={
                        !record.resent && !record.dispensed ? "top" : "left"
                      }
                      title={
                        record.dispensed
                          ? intl.formatMessage({ id: "dispensed_file" })
                          : !record.resent
                            ? intl.formatMessage({
                                id: isPackage ? "resend_package" : "resend",
                              })
                            : intl.formatMessage({
                                id: isPackage
                                  ? "already_resent_package"
                                  : "already_resent",
                              })
                      }
                    >
                      <VscRefresh size={22} />
                    </Tooltip>
                  </BtnRefresh>
                </>
              )}
            </Actions>
          );
        },
      },
    ],
    [
      intl,
      formatDate,
      handleSendFile,
      handleRemoveFile,
      handleDownload,
      userLogged,
      handleSendPackage,
    ],
  );

  // Aplicar paginação nos dados filtrados
  const paginatedPendingDocs = useMemo(() => {
    const currentPage = tablePaginationPending.current - 1;
    const pageSize = tablePaginationPending.pageSize;
    const startIndex = currentPage * pageSize;
    const endIndex = startIndex + pageSize;

    return filteredPendingDocs.slice(startIndex, endIndex);
  }, [filteredPendingDocs, tablePaginationPending]);

  const paginatedSubmittedDocs = useMemo(() => {
    const currentPage = tablePaginationSubmitted.current - 1;
    const pageSize = tablePaginationSubmitted.pageSize;
    const startIndex = currentPage * pageSize;
    const endIndex = startIndex + pageSize;

    return filteredSubmittedDocs.slice(startIndex, endIndex);
  }, [filteredSubmittedDocs, tablePaginationSubmitted]);

  const handleGetInfoTablePending = useCallback(
    (page = 0, pageSize = 10, search = "") => {
      handleLoading(true);

      // Atualizar busca
      setSearchPendingDocs(search);

      setTimeout(() => {
        // Se é uma mudança de página (não de busca), apenas atualizar paginação
        if (search === searchPendingDocs) {
          setTablePaginationPending((prev) => ({
            ...prev,
            current: page + 1,
            pageSize,
          }));
        }
        // Se é mudança de busca, o useEffect vai cuidar do resto

        handleLoading(false);
      }, 100);
    },
    [handleLoading, searchPendingDocs],
  );

  const handleGetInfoTableSubmitted = useCallback(
    (page = 0, pageSize = 10, search = "") => {
      handleLoading(true);

      // Atualizar busca
      setSearchSubmittedDocs(search);

      setTimeout(() => {
        // Se é uma mudança de página (não de busca), apenas atualizar paginação
        if (search === searchSubmittedDocs) {
          setTablePaginationSubmitted((prev) => ({
            ...prev,
            current: page + 1,
            pageSize,
          }));
        }
        // Se é mudança de busca, o useEffect vai cuidar do resto

        handleLoading(false);
      }, 100);
    },
    [handleLoading, searchSubmittedDocs],
  );

  const documentStats = useMemo(() => {
    const allDocs = [...(documentsList?.submittedDocs || [])];

    const approvedStatuses = ["APPROVED", "APPROVED_BY_SYSTEM"];

    const approved = allDocs.filter((doc) =>
      approvedStatuses.includes(doc.status),
    ).length;
    const pending = allDocs.filter((doc) => doc.status === "PENDING").length;
    const rejected = allDocs.filter((doc) => doc.status === "REJECTED").length;

    return { approved, pending, rejected };
  }, [documentsList?.submittedDocs]);

  const fetchDocumentsByFlow = useCallback(() => {
    setIsLoadingDocs(true);

    dispatch(
      fetchDocumentsList(
        contract.value,
        (documents) => {
          const pendingTotal = documents?.pendingDocs?.length || 0;
          const submittedTotal = documents?.submittedDocs?.length || 0;

          setTablePaginationPending((prev) => ({
            ...prev,
            total: pendingTotal,
            current: 1,
          }));

          setTablePaginationSubmitted((prev) => ({
            ...prev,
            total: submittedTotal,
            current: 1,
          }));

          setIsLoadingDocs(false);
        },
        () => {
          notificationRef.current.displayError(
            intl.formatMessage({ id: "error" }),
            "fetch-documents-error-message",
          );
          setIsLoadingDocs(false);
        },
      ),
    );
  }, [contract.value, dispatch, intl]);

  const confirmDeleteDocument = useCallback(async () => {
    if (!documentToDelete) return;

    const isPackage =
      Boolean(documentToDelete.documentPackage) &&
      documentToDelete.items?.length > 0;

    const documentIds = isPackage
      ? documentToDelete.items
          .map((item) => item.documentExecutionId)
          .filter(Boolean)
      : null;

    const pathId =
      isPackage && documentIds?.length > 0
        ? documentIds[0]
        : documentToDelete.idExecution;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
      ...(documentIds?.length > 0 && { data: { documentIds } }),
    };

    try {
      await api.delete(`/upload-flow/documents/${pathId}`, config);

      notification.displaySuccess(
        intl.formatMessage({
          id: isPackage
            ? "approval_documents.delete_package_success"
            : "approval_documents.delete_document_success",
        }),
        "delete-uploaded-document-success-message",
      );

      fetchDocumentsByFlow();

      dispatch(
        checkMandatoryDocuments(
          contract.value,
          (hasMandatory) => {},
          (error) => {},
        ),
      );
    } catch (error) {
      const backendCode =
        error?.response?.data?.code || error?.response?.data?.errorCode;

      const errorMessageId =
        backendCode === -46016
          ? "approval_documents.staff_cannot_delete_others"
          : "approval_documents.delete_error";

      notification.displayError(
        intl.formatMessage({ id: errorMessageId }),
        "delete-uploaded-flow-error-message",
      );
    } finally {
      setDeleteModalOpen(false);
      setDocumentToDelete(null);
    }
  }, [
    documentToDelete,
    token,
    intl,
    fetchDocumentsByFlow,
    dispatch,
    contract.value,
  ]);

  useEffect(() => {
    if (activeTab.activeTab === "1") {
      fetchDocumentsByFlow();
    }
  }, [fetchDocumentsByFlow, activeTab.activeTab]);

  // Inicializar dados originais quando documentsList mudar
  useEffect(() => {
    if (documentsList) {
      const pendingDocs = documentsList?.pendingDocs || [];
      const submittedDocs = documentsList?.submittedDocs || [];

      setOriginalPendingDocs(pendingDocs);
      setOriginalSubmittedDocs(submittedDocs);

      // Sempre inicializar com dados originais completos
      setFilteredPendingDocs([...pendingDocs]);
      setFilteredSubmittedDocs([...submittedDocs]);

      // Resetar paginação para estado inicial
      setTablePaginationPending({
        current: 1,
        defaultCurrent: 1,
        pageSize: 5,
        showQuickJumper: true,
        total: pendingDocs.length,
      });

      setTablePaginationSubmitted({
        current: 1,
        defaultCurrent: 1,
        pageSize: 5,
        showQuickJumper: true,
        total: submittedDocs.length,
      });

      // Limpar buscas se existirem
      setSearchPendingDocs("");
      setSearchSubmittedDocs("");
    }
  }, [documentsList]);

  // Aplicar filtros quando as buscas mudarem
  useEffect(() => {
    // Só aplicar filtros se já temos dados originais carregados
    if (originalPendingDocs.length > 0 || originalSubmittedDocs.length > 0) {
      if (
        searchPendingDocs.trim() === "" &&
        searchSubmittedDocs.trim() === ""
      ) {
        // Reset completo se ambas as buscas estão vazias
        setFilteredPendingDocs([...originalPendingDocs]);
        setFilteredSubmittedDocs([...originalSubmittedDocs]);

        setTablePaginationPending((prev) => ({
          ...prev,
          current: 1,
          total: originalPendingDocs.length,
        }));

        setTablePaginationSubmitted((prev) => ({
          ...prev,
          current: 1,
          total: originalSubmittedDocs.length,
        }));
      } else {
        // Aplicar filtros manualmente para evitar dependências circulares
        let filteredPending = [...originalPendingDocs];
        if (searchPendingDocs.trim()) {
          filteredPending = filteredPending.filter((doc) =>
            doc.fileName
              ?.toLowerCase()
              .includes(searchPendingDocs.toLowerCase()),
          );
        }
        setFilteredPendingDocs(filteredPending);

        let filteredSubmitted = [...originalSubmittedDocs];
        if (searchSubmittedDocs.trim()) {
          const searchTerm = searchSubmittedDocs.toLowerCase();
          filteredSubmitted = filteredSubmitted.filter((doc) => {
            const fileName = doc.fileName?.toLowerCase() || "";
            const status = doc.status?.toLowerCase() || "";

            // Traduzir status para busca
            let translatedStatus = "";
            if (status === "pending") {
              translatedStatus = intl
                .formatMessage({ id: "documents.under_analysis" })
                .toLowerCase();
            } else if (status === "approved") {
              translatedStatus = intl
                .formatMessage({ id: "approved" })
                .toLowerCase();
            } else if (status === "rejected") {
              translatedStatus = intl
                .formatMessage({ id: "reproved" })
                .toLowerCase();
            }

            return (
              fileName.includes(searchTerm) ||
              status.includes(searchTerm) ||
              translatedStatus.includes(searchTerm)
            );
          });
        }
        setFilteredSubmittedDocs(filteredSubmitted);

        // Atualizar totais e resetar paginação
        setTablePaginationPending((prev) => ({
          ...prev,
          current: 1,
          total: filteredPending.length,
        }));

        setTablePaginationSubmitted((prev) => ({
          ...prev,
          current: 1,
          total: filteredSubmitted.length,
        }));
      }
    }
  }, [
    searchPendingDocs,
    searchSubmittedDocs,
    originalPendingDocs,
    originalSubmittedDocs,
    intl,
  ]);

  console.log(documentsLoading);

  return (
    <Container>
      <SendDocumentModal
        visible={modalSendDocumentVisible}
        documentId={documentId}
        documentName={documentName}
        flowId={Number(id)}
        flowName={flowName}
        opportunityId={opportunityId}
        eventId={eventId}
        allowedFileExtensions={allowedFileExtensions}
        isPackage={isPackage}
        packageDocuments={packageDocuments}
        onFinish={({ success } = {}) => {
          setModalSendDocumentVisible(false);
          if (success) fetchDocumentsByFlow(); // Só recarrega se sucesso
        }}
      />

      <StatsContainer>
        <StatsCard>
          <StatsContent>
            <StatsLabel>
              {intl.formatMessage({ id: "many_approved" })}
            </StatsLabel>
            <StatsNumber data-test="client-aprroved-documents-count">
              {documentStats.approved}
            </StatsNumber>
          </StatsContent>
          <StatsIcon className="approved">
            <IoCheckmarkSharp size={24} />
          </StatsIcon>
        </StatsCard>

        <StatsCard>
          <StatsContent>
            <StatsLabel>{intl.formatMessage({ id: "in_analysis" })}</StatsLabel>
            <StatsNumber>{documentStats.pending}</StatsNumber>
          </StatsContent>
          <StatsIcon className="pending">
            <Spinner size={24} color={"#C0780C"} />
          </StatsIcon>
        </StatsCard>

        <StatsCard>
          <StatsContent>
            <StatsLabel>
              {intl.formatMessage({ id: "many_reproved" })}
            </StatsLabel>
            <StatsNumber>{documentStats.rejected}</StatsNumber>
          </StatsContent>
          <StatsIcon className="reproved">
            <IoCloseSharp size={24} color={"#EF4444"} />
          </StatsIcon>
        </StatsCard>
      </StatsContainer>

      <Content>
        <Table
          title={`${intl.formatMessage({ id: "documents_wait" })} (${
            filteredPendingDocs?.length ?? 0
          })`}
          dataSource={paginatedPendingDocs ?? []}
          columns={columnsWait}
          rowKey="id"
          loading={isLoadingDocs}
          tablePagination={tablePaginationPending}
          handleGetInfoTable={handleGetInfoTablePending}
          haveExpandable
          rowExpandable={(record) => Boolean(record?.documentPackage)}
          expandedRowRender={(record) => (
            <ExpandedDocumentRow
              columns={columnsWait}
              rowKey="id"
              eventId={event.value}
              uploadFlowId={record.id}
              executionId={record.idExecution}
              token={token}
              queryParams={{ opportunityId: contract.value }}
              parentRecord={record}
              onSendPackage={handleSendPackage}
            />
          )}
        />

        <div style={{ marginTop: "24px" }} />
        <Table
          scroll={{ x: SUBMITTED_TABLE_MIN_WIDTH }}
          title={`${intl.formatMessage({ id: "documents_send" })} (${
            filteredSubmittedDocs?.length ?? 0
          })`}
          dataSource={paginatedSubmittedDocs ?? []}
          columns={columnsSend}
          loading={isLoadingDocs}
          rowKey="idExecution"
          tablePagination={tablePaginationSubmitted}
          handleGetInfoTable={handleGetInfoTableSubmitted}
          haveExpandable
          rowExpandable={(record) => Boolean(record?.documentPackage)}
          expandedRowRender={(record) => (
            <ExpandedDocumentRow
              columns={columnsSend}
              rowKey="idExecution"
              eventId={event.value}
              executionId={record.idExecution}
              uploadFlowId={record.id}
              token={token}
              queryParams={{ opportunityId: contract.value }}
            />
          )}
        />
      </Content>

      <ConfirmationModal
        open={deleteModalOpen}
        handleClose={() => {
          setDeleteModalOpen(false);
          setDocumentToDelete(null);
        }}
        id="delete-document-modal"
        message={intl.formatMessage({ id: "delete_document_confirmation" })}
        confirmation={confirmDeleteDocument}
        title={intl.formatMessage({ id: "delete_document" })}
        labelBtnConfir="yes"
        labelClose="no"
      />
    </Container>
  );
};

export default DocumentNotSend;
